/* Users & roles area: user list, role editor, invitations. */
const users = {
  // Page header & tabs
  'Users': 'Pengguna',
  'Roles': 'Peran',
  'Invitations': 'Undangan',
  'Manage who can access the system and what they can do, with per-property roles and approval limits.': 'Kelola siapa yang dapat mengakses sistem dan apa yang dapat mereka lakukan, dengan peran per properti dan batas persetujuan.',
  'User management sections': 'Bagian manajemen pengguna',
  'New role': 'Peran baru',
  'Invite user': 'Undang pengguna',
  'Could not load users': 'Tidak dapat memuat pengguna',

  // Users tab
  'Unknown role': 'Peran tidak dikenal',
  'Org-wide': 'Seluruh organisasi',
  'You': 'Anda',
  'No roles': 'Tanpa peran',
  'Deactivate': 'Nonaktifkan',
  'Activate': 'Aktifkan',
  'User deactivated': 'Pengguna dinonaktifkan',
  'User activated': 'Pengguna diaktifkan',
  'User updated': 'Pengguna diperbarui',
  'User deleted': 'Pengguna dihapus',
  'Could not update user': 'Tidak dapat memperbarui pengguna',
  'Could not delete user': 'Tidak dapat menghapus pengguna',
  'Delete user': 'Hapus pengguna',
  'Send reset': 'Kirim atur ulang',
  'Password reset email sent to {email}': 'Email atur ulang kata sandi dikirim ke {email}',
  'Could not send reset email': 'Tidak dapat mengirim email atur ulang',
  'Delete {name} ({email})? This permanently removes their account and sign-in access.': 'Hapus {name} ({email})? Tindakan ini menghapus akun dan akses masuk mereka secara permanen.',

  // User editor
  'Edit user': 'Ubah pengguna',
  'First name': 'Nama depan',
  'Last name': 'Nama belakang',
  'You cannot deactivate your own account.': 'Anda tidak dapat menonaktifkan akun Anda sendiri.',
  'Roles & access': 'Peran & akses',

  // Role assignments editor
  'Organization-wide (all properties)': 'Seluruh organisasi (semua properti)',
  'No roles assigned yet. Add at least one role.': 'Belum ada peran yang ditetapkan. Tambahkan minimal satu peran.',
  'Role': 'Peran',
  'Scope': 'Cakupan',
  'Remove assignment': 'Hapus penugasan',
  'Choose properties…': 'Pilih properti…',
  "Approval limit (optional, in the property's currency)": 'Batas persetujuan (opsional, dalam mata uang properti)',
  'No limit': 'Tanpa batas',
  'Add role assignment': 'Tambah penugasan peran',
  'Assign at least one role.': 'Tetapkan minimal satu peran.',
  'Choose a role for every assignment.': 'Pilih peran untuk setiap penugasan.',
  'Choose a scope (organization-wide or at least one property) for every role.': 'Pilih cakupan (seluruh organisasi atau minimal satu properti) untuk setiap peran.',

  // Roles tab & role editor
  'Built-in': 'Bawaan',
  'Custom': 'Kustom',
  'All permissions': 'Semua izin',
  '{count} permissions': '{count} izin',
  'Role created': 'Peran dibuat',
  'Role updated': 'Peran diperbarui',
  'Role deleted': 'Peran dihapus',
  'Could not save role': 'Tidak dapat menyimpan peran',
  'Could not delete role': 'Tidak dapat menghapus peran',
  'Delete role': 'Hapus peran',
  'Delete the role "{name}"? This cannot be undone.': 'Hapus peran "{name}"? Tindakan ini tidak dapat dibatalkan.',
  'Edit role': 'Ubah peran',
  '{name} (built-in)': '{name} (bawaan)',
  'Built-in roles are read-only. Create a custom role to tailor permissions.': 'Peran bawaan hanya dapat dibaca. Buat peran kustom untuk menyesuaikan izin.',
  'Role name': 'Nama peran',
  'Create role': 'Buat peran',

  // Invitations
  'No invitations': 'Belum ada undangan',
  "Invite teammates to join your organization. They'll set their own password from the emailed link.": 'Undang rekan kerja untuk bergabung dengan organisasi Anda. Mereka akan mengatur kata sandi sendiri melalui tautan yang dikirim lewat email.',
  'Accepted': 'Diterima',
  'Revoked': 'Dicabut',
  'Expired': 'Kedaluwarsa',
  'Expires {date}': 'Kedaluwarsa {date}',
  'Resend': 'Kirim ulang',
  'Revoke': 'Cabut',
  'Invitation sent': 'Undangan terkirim',
  'Invitation resent': 'Undangan dikirim ulang',
  'Invitation revoked': 'Undangan dicabut',
  'Could not resend': 'Tidak dapat mengirim ulang',
  'Could not revoke': 'Tidak dapat mencabut',
  'New invite link copied': 'Tautan undangan baru disalin',
  'Email is required.': 'Email wajib diisi.',
  'Could not send invitation.': 'Tidak dapat mengirim undangan.',
  'Invite link copied': 'Tautan undangan disalin',
  'Could not copy link': 'Tidak dapat menyalin tautan',
  'Invitation sent to': 'Undangan terkirim ke',
  'Invitation link': 'Tautan undangan',
  'Share this link if email delivery isn’t configured yet. It expires automatically.': 'Bagikan tautan ini jika pengiriman email belum dikonfigurasi. Tautan akan kedaluwarsa secara otomatis.',
  'Copy link': 'Salin tautan',
  'Invite another': 'Undang lagi',
  'First name (optional)': 'Nama depan (opsional)',
  'Last name (optional)': 'Nama belakang (opsional)',
  'Send invitation': 'Kirim undangan',
};

export default users;
